// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Vector Lines.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Inter", sans-serif;
}

.trackmain_container {
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.scrolllink {
  justify-content: flex-start;
  margin-right: 90%;
  width: 100px;
  margin-top: 1px;
  text-decoration: none;
  color: white;
  text-align: left;
  justify-content: left;
  align-items: flex-start;
}

.track-container {
  /* height: 100%; */
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  /* height: 90vh; */
}

.track-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #f4f4f4;
  /* height: 90vh; */
  width: 100%;
  margin: auto;
  /* background-color: rgb(0, 17, 255); */
}

.track-textarea {
  background: transparent;
}

.track .notes p {
  background: #15141d;
}

.track-content h1 {
  background: transparent;
  width: 70%;
  margin: 0 auto;
  margin-top: 3rem;
  font-family: Eczar;
  font-size: 56px;
  font-weight: 600;
  letter-spacing: 0em;
  text-align: center;
  line-height: 100px;
  margin-bottom: 12px;
}

.track-content h1 span {
  background: transparent;
}

.track-content p {
  font-size: 18px;
  background: #15141d;
  font-family: inter;
  word-spacing: 1px;
  font-weight: 400;
  /* height: 64px; */
  line-height: 32px;
  text-align: center;
  color: #b3b3b3;
  width: 70%;
  margin: 0 auto;
  margin-bottom: 24px;
  background: transparent;
}

.reserve-btns button {
  height: 48px;
  font-size: 16px;
  font-family: inter;
  font-weight: 500;
  margin-top: 50px;
  border-radius: 64px;
  border: solid 1px rgba(255, 223, 188, 1);
  justify-content: center;
  gap: 10px;
  padding: 0;
  width: 192px;
  background-color: rgba(251, 133, 0, 1);
}

.datamastery-container {
  color: #fff;
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  border-radius: 16px;
  min-height: 710px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 2rem auto 2rem;
  border: 3px solid rgba(245, 238, 238, 0.035);
}

.datamastery-container .wrapper {
  margin-top: 0;
  padding-block: 1rem;
}

.datamastery-infos h2 {
  font-family: Eczar;
  font-size: 48px;
  font-weight: 700;
  line-height: 85px;
  letter-spacing: 0em;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin: 3rem auto 16px;
  width: 48rem;
  height: 5rem;
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
}

.datamastery-infos p {
  color: B3B3B3;
  font-family: Inter;
  word-spacing: 1px;
  font-size: 16px;
  font-weight: 400;
  width: 48rem;
  height: 6rem;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
  margin: 0 auto;
  padding: 1rem;
  align-items: stretch; /* ensure equal card heights within a row */
}

.datamastery-track p {
  font-family: Inter;
  word-spacing: 1px;
  font-size: 18px;
  font-weight: 500;
  width: 715px;
  height: 96px;
  line-height: 32px;
  letter-spacing: 0em;
  text-align: center;
  justify-content: center;
  align-items: center;
  /* background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    ); */
}

.datamastery-infos {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
}

.datamastery-infos .orange {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
}

.datamastery-wrapper .track-type {
  border-radius: 16px;
  color: #f4f4f4;
  height: 40%;
  display: flex;
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
}

.track {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  /* height: 400px; */ /* Removed fixed height to allow cards to stretch */
  /* width: 350px; */ /* Removed fixed width to allow grid to manage size */
  border: 4px solid rgba(75, 75, 75, 0.25);
  border-radius: 16px;
}

.track_content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
}



.track_modules {
  margin-top: auto; /* Pushes to the bottom */
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 1rem;
}

.week-button,
.track_select_btn button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px; /* consistent height for both buttons */
  padding: 0 16px; /* horizontal padding only; height controlled above */
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;
  line-height: 1;
}

.week-button {
  background-color: #3a3a3a;
  color: #f0f0f0;
  border: 1px solid #555;
}

.track_select_btn {
  text-decoration: none;
  display: block; /* This ensures the Link component behaves correctly in a flex container */
}

.track_select_btn button {
  background-color: #ff6b35;
  color: white;
}

.track_select_btn button:hover {
  background-color: #e55a2b;
}

/* Removed duplicate .wrapper override to retain grid layout for equal card heights */

.track_info {
  border-radius: 10px;
}

.mentors_text p {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0em;
  text-align: center;
  background: #15141d;
  margin-bottom: 16px;
}

.mentor_images {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  object-fit: cover;
  overflow: hidden;
  display: block;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .track-content h1 {
    font-size: 36px;
    line-height: unset;
  }

  .datamastery-infos {
    padding: 2rem 5%;
  }

  .datamastery-infos p,
  .datamastery-infos h2 {
    width: unset;
    height: unset;
  }

  .datamastery-container .wrapper {
    padding-block: unset;
  }

  .track-textarea {
    margin-top: 3rem;
  }
}

/* @media screen and (max-width: 767.98px) {
  .track-content {
    width: 100%;
  }

  .track-content h1 {
    font-size: 34px;
    line-height: 1.5;
    width: 90%;
  }

  .track-content p {
    height: auto;
    width: 100%;
  }

  .trackmain_container .datamastery-container {
    background-color: teal;
  }

  .trackmain_container .datamastery-wrapper {
    background-color: red;
    width: 100%;
  }

  .trackmain_container .datamastery-infos {
    color: yellow;
  }
} */

/* 
@media (min-width: 768px) and (max-width: 991.98px) {
  .trackmain_container {
    width: 100%;
  }

  .track-container {
    width: 100%;
    justify-content: center;
  }

  .track-content {
    margin-top: 0.5rem;
    width: 80%;
  }

  .scrolllink {
    margin-top: 0;
    margin-right: 65%;
    margin-bottom: 80px;
  }

  .track-content h1 {
    font-size: 50px;
    margin: 0 auto 40px;
    line-height: 60px;
    width: 90%;
    justify-content: center;
  }

  .track-content p {
    font-size: 18px;
    width: 90%;
    height: auto;
    line-height: 30px;
    margin: 42px auto 32px;
    justify-content: center;
    text-align: center;
  }

  .track-content .reserve-btns {
    margin-top: 40px;
  }
  .track-content .reserve-btns button {
    height: 36px;
    margin-top: 1.5rem;
    font-size: 16px;
    color: #000000;
  }

  .trackmain_container .datamastery-container {
    height: 100%;
    width: 80%;
    margin: 10px auto;
  }

  .trackmain_container .datamastery-wrapper {
    margin: 0 auto;
    height: 1600px;
    width: 70%;
  }

  .datamastery-container {
    width: 100%;
  }
  .datamastery-wrapper {
    background-color: rgba(28, 27, 38, 1);
  }

  .trackmain_container .datamastery-infos {
    width: 100%;
    background-color: rgba(28, 27, 38, 1);
  }

  .trackmain_container .datamastery-infos h2 {
    margin: 24px auto 24px;
    line-height: 56px;
    font-size: 50px;
    width: 100%;
  }

  .trackmain_container .datamastery-infos h2 span {
    background: transparent;
  }

  .trackmain_container .datamastery-infos p {
    width: 90%;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    margin-top: 10%;
    margin-bottom: 4%;
  }

  .trackmain_container .track {
    border: 3px solid rgba(75, 75, 75, 0.25);
    background: rgba(21, 20, 29, 1);
  }

  .trackmain_container .mentors_text {
    margin-top: 0 auto;
    margin-bottom: 40px;
  }

  .trackmain_container .mentors_text .oranges {
    font-size: 24px;
  }

  .datamastery-wrapper .track-types {
    width: 100%;
  }

  .track-types .wrapper {
    height: auto;
  }

  .track-types .track {
    width: 96%;
    height: 100%;
    padding: auto;
  }

  .beginner-type,
  .intermediate-type {
    width: 100%;
    height: auto;
  }

  .mentors .mentors_text h1 .oranges {
    width: 80%;
    font-size: 50px;
  }

  .mentors .mentors_text p {
    width: 70%;
    text-align: center;
  }

  .mentors_container .mentor_para {
    background: rgba(21, 20, 29, 1);
  }
  .mentors_container .mentor_para h3 {
    margin: 0 auto;
  }

  .mentor_para p {
    background: rgba(21, 20, 29, 1);
  }
} */

/* @media screen and (max-width: 1200px) {
.trackmain_container{
  background-color: red;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

}


.track-container{
  width: 100%;
  height: 100vh;
  background-color: aqua;
}

.track-content{
  max-width: 100%;
    height: 80vh;
    margin-bottom: 30%;
}
  .trackmain_container .datamastery-container{
    background-color: cornflowerblue;
    color: darkmagenta;
    width: 100%;
    height: 100vh;
  }
} */

/* @media screen and (min-width: 1200px) {

  
  .datamastery-container{
  }

  .track-type{
    display: flex;
    flex-direction: column;
    height: 70vh;
  }

  @media screen and (min-width: 800px) {
.wrapper{
  display: flex;
  flex-direction: column;
}


.datamastery-container{
  }
.track-type{
  display: flex;
  flex-direction: column;
  height: 60vh;
}
.track_modules{
  justify-content: center;
  align-items: center;
  flex-direction: column;
  display: flex;
  margin: 0 auto;
  height: auto;
}





  }
} */
`, "",{"version":3,"sources":["webpack://./src/styles/Tracks.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yDAAkD;EAClD,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX;;;;;KAKG;EACH,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ;;;;;KAKG;AACL;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;EACd,aAAa;EACb,oBAAoB,EAAE,2CAA2C;AACnE;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB;;;;;QAKM;AACR;;AAEA;EACE;;;;;KAKG;AACL;;AAEA;EACE;;;;;KAKG;AACL;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,aAAa;EACb;;;;;KAKG;AACL;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB,EAAE,mDAAmD;EACxE,kBAAkB,EAAE,qDAAqD;EACzE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb;;;;AAIA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAE,uCAAuC;EACrD,eAAe,EAAE,qDAAqD;EACtE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc,EAAE,0EAA0E;AAC5F;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qFAAqF;;AAErF;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAoJG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwCG","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n}\n\n.trackmain_container {\n  overflow-y: scroll;\n  scroll-snap-type: y mandatory;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.scrolllink {\n  justify-content: flex-start;\n  margin-right: 90%;\n  width: 100px;\n  margin-top: 1px;\n  text-decoration: none;\n  color: white;\n  text-align: left;\n  justify-content: left;\n  align-items: flex-start;\n}\n\n.track-container {\n  /* height: 100%; */\n  margin-top: 28px;\n  display: flex;\n  flex-direction: column;\n  /* height: 90vh; */\n}\n\n.track-content {\n  background-image: url(../images/Vector\\ Lines.png);\n  background-position: center;\n  background-size: contain;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  color: #f4f4f4;\n  /* height: 90vh; */\n  width: 100%;\n  margin: auto;\n  /* background-color: rgb(0, 17, 255); */\n}\n\n.track-textarea {\n  background: transparent;\n}\n\n.track .notes p {\n  background: #15141d;\n}\n\n.track-content h1 {\n  background: transparent;\n  width: 70%;\n  margin: 0 auto;\n  margin-top: 3rem;\n  font-family: Eczar;\n  font-size: 56px;\n  font-weight: 600;\n  letter-spacing: 0em;\n  text-align: center;\n  line-height: 100px;\n  margin-bottom: 12px;\n}\n\n.track-content h1 span {\n  background: transparent;\n}\n\n.track-content p {\n  font-size: 18px;\n  background: #15141d;\n  font-family: inter;\n  word-spacing: 1px;\n  font-weight: 400;\n  /* height: 64px; */\n  line-height: 32px;\n  text-align: center;\n  color: #b3b3b3;\n  width: 70%;\n  margin: 0 auto;\n  margin-bottom: 24px;\n  background: transparent;\n}\n\n.reserve-btns button {\n  height: 48px;\n  font-size: 16px;\n  font-family: inter;\n  font-weight: 500;\n  margin-top: 50px;\n  border-radius: 64px;\n  border: solid 1px rgba(255, 223, 188, 1);\n  justify-content: center;\n  gap: 10px;\n  padding: 0;\n  width: 192px;\n  background-color: rgba(251, 133, 0, 1);\n}\n\n.datamastery-container {\n  color: #fff;\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n  border-radius: 16px;\n  min-height: 710px;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 2rem auto 2rem;\n  border: 3px solid rgba(245, 238, 238, 0.035);\n}\n\n.datamastery-container .wrapper {\n  margin-top: 0;\n  padding-block: 1rem;\n}\n\n.datamastery-infos h2 {\n  font-family: Eczar;\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 85px;\n  letter-spacing: 0em;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  margin: 3rem auto 16px;\n  width: 48rem;\n  height: 5rem;\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n}\n\n.datamastery-infos p {\n  color: B3B3B3;\n  font-family: Inter;\n  word-spacing: 1px;\n  font-size: 16px;\n  font-weight: 400;\n  width: 48rem;\n  height: 6rem;\n  line-height: 30px;\n  letter-spacing: 0em;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n}\n\n.wrapper {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 20px;\n  margin: 0 auto;\n  padding: 1rem;\n  align-items: stretch; /* ensure equal card heights within a row */\n}\n\n.datamastery-track p {\n  font-family: Inter;\n  word-spacing: 1px;\n  font-size: 18px;\n  font-weight: 500;\n  width: 715px;\n  height: 96px;\n  line-height: 32px;\n  letter-spacing: 0em;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  /* background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    ); */\n}\n\n.datamastery-infos {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n}\n\n.datamastery-infos .orange {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n}\n\n.datamastery-wrapper .track-type {\n  border-radius: 16px;\n  color: #f4f4f4;\n  height: 40%;\n  display: flex;\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n}\n\n.track {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  /* height: 400px; */ /* Removed fixed height to allow cards to stretch */\n  /* width: 350px; */ /* Removed fixed width to allow grid to manage size */\n  border: 4px solid rgba(75, 75, 75, 0.25);\n  border-radius: 16px;\n}\n\n.track_content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n\n\n.track_modules {\n  margin-top: auto; /* Pushes to the bottom */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding-bottom: 1rem;\n}\n\n.week-button,\n.track_select_btn button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px; /* consistent height for both buttons */\n  padding: 0 16px; /* horizontal padding only; height controlled above */\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.week-button {\n  background-color: #3a3a3a;\n  color: #f0f0f0;\n  border: 1px solid #555;\n}\n\n.track_select_btn {\n  text-decoration: none;\n  display: block; /* This ensures the Link component behaves correctly in a flex container */\n}\n\n.track_select_btn button {\n  background-color: #ff6b35;\n  color: white;\n}\n\n.track_select_btn button:hover {\n  background-color: #e55a2b;\n}\n\n/* Removed duplicate .wrapper override to retain grid layout for equal card heights */\n\n.track_info {\n  border-radius: 10px;\n}\n\n.mentors_text p {\n  color: #fff;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 32px;\n  letter-spacing: 0em;\n  text-align: center;\n  background: #15141d;\n  margin-bottom: 16px;\n}\n\n.mentor_images {\n  width: 250px;\n  height: 250px;\n  border-radius: 50%;\n  object-fit: cover;\n  overflow: hidden;\n  display: block;\n  margin: 0 auto;\n}\n\n@media screen and (max-width: 768px) {\n  .track-content h1 {\n    font-size: 36px;\n    line-height: unset;\n  }\n\n  .datamastery-infos {\n    padding: 2rem 5%;\n  }\n\n  .datamastery-infos p,\n  .datamastery-infos h2 {\n    width: unset;\n    height: unset;\n  }\n\n  .datamastery-container .wrapper {\n    padding-block: unset;\n  }\n\n  .track-textarea {\n    margin-top: 3rem;\n  }\n}\n\n/* @media screen and (max-width: 767.98px) {\n  .track-content {\n    width: 100%;\n  }\n\n  .track-content h1 {\n    font-size: 34px;\n    line-height: 1.5;\n    width: 90%;\n  }\n\n  .track-content p {\n    height: auto;\n    width: 100%;\n  }\n\n  .trackmain_container .datamastery-container {\n    background-color: teal;\n  }\n\n  .trackmain_container .datamastery-wrapper {\n    background-color: red;\n    width: 100%;\n  }\n\n  .trackmain_container .datamastery-infos {\n    color: yellow;\n  }\n} */\n\n/* \n@media (min-width: 768px) and (max-width: 991.98px) {\n  .trackmain_container {\n    width: 100%;\n  }\n\n  .track-container {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .track-content {\n    margin-top: 0.5rem;\n    width: 80%;\n  }\n\n  .scrolllink {\n    margin-top: 0;\n    margin-right: 65%;\n    margin-bottom: 80px;\n  }\n\n  .track-content h1 {\n    font-size: 50px;\n    margin: 0 auto 40px;\n    line-height: 60px;\n    width: 90%;\n    justify-content: center;\n  }\n\n  .track-content p {\n    font-size: 18px;\n    width: 90%;\n    height: auto;\n    line-height: 30px;\n    margin: 42px auto 32px;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .track-content .reserve-btns {\n    margin-top: 40px;\n  }\n  .track-content .reserve-btns button {\n    height: 36px;\n    margin-top: 1.5rem;\n    font-size: 16px;\n    color: #000000;\n  }\n\n  .trackmain_container .datamastery-container {\n    height: 100%;\n    width: 80%;\n    margin: 10px auto;\n  }\n\n  .trackmain_container .datamastery-wrapper {\n    margin: 0 auto;\n    height: 1600px;\n    width: 70%;\n  }\n\n  .datamastery-container {\n    width: 100%;\n  }\n  .datamastery-wrapper {\n    background-color: rgba(28, 27, 38, 1);\n  }\n\n  .trackmain_container .datamastery-infos {\n    width: 100%;\n    background-color: rgba(28, 27, 38, 1);\n  }\n\n  .trackmain_container .datamastery-infos h2 {\n    margin: 24px auto 24px;\n    line-height: 56px;\n    font-size: 50px;\n    width: 100%;\n  }\n\n  .trackmain_container .datamastery-infos h2 span {\n    background: transparent;\n  }\n\n  .trackmain_container .datamastery-infos p {\n    width: 90%;\n    font-size: 18px;\n    line-height: 30px;\n    text-align: center;\n    margin-top: 10%;\n    margin-bottom: 4%;\n  }\n\n  .trackmain_container .track {\n    border: 3px solid rgba(75, 75, 75, 0.25);\n    background: rgba(21, 20, 29, 1);\n  }\n\n  .trackmain_container .mentors_text {\n    margin-top: 0 auto;\n    margin-bottom: 40px;\n  }\n\n  .trackmain_container .mentors_text .oranges {\n    font-size: 24px;\n  }\n\n  .datamastery-wrapper .track-types {\n    width: 100%;\n  }\n\n  .track-types .wrapper {\n    height: auto;\n  }\n\n  .track-types .track {\n    width: 96%;\n    height: 100%;\n    padding: auto;\n  }\n\n  .beginner-type,\n  .intermediate-type {\n    width: 100%;\n    height: auto;\n  }\n\n  .mentors .mentors_text h1 .oranges {\n    width: 80%;\n    font-size: 50px;\n  }\n\n  .mentors .mentors_text p {\n    width: 70%;\n    text-align: center;\n  }\n\n  .mentors_container .mentor_para {\n    background: rgba(21, 20, 29, 1);\n  }\n  .mentors_container .mentor_para h3 {\n    margin: 0 auto;\n  }\n\n  .mentor_para p {\n    background: rgba(21, 20, 29, 1);\n  }\n} */\n\n/* @media screen and (max-width: 1200px) {\n.trackmain_container{\n  background-color: red;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n\n}\n\n\n.track-container{\n  width: 100%;\n  height: 100vh;\n  background-color: aqua;\n}\n\n.track-content{\n  max-width: 100%;\n    height: 80vh;\n    margin-bottom: 30%;\n}\n  .trackmain_container .datamastery-container{\n    background-color: cornflowerblue;\n    color: darkmagenta;\n    width: 100%;\n    height: 100vh;\n  }\n} */\n\n/* @media screen and (min-width: 1200px) {\n\n  \n  .datamastery-container{\n  }\n\n  .track-type{\n    display: flex;\n    flex-direction: column;\n    height: 70vh;\n  }\n\n  @media screen and (min-width: 800px) {\n.wrapper{\n  display: flex;\n  flex-direction: column;\n}\n\n\n.datamastery-container{\n  }\n.track-type{\n  display: flex;\n  flex-direction: column;\n  height: 60vh;\n}\n.track_modules{\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  display: flex;\n  margin: 0 auto;\n  height: auto;\n}\n\n\n\n\n\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
